<div [class.main-content]="!embedded" [class.vendor-create-embedded]="embedded" *ngIf="vendorForm">
	<div class="container-fluid">
		<div class="card">
			<div *ngIf="!embedded" class="card-header card-header-{{ color }}-5">
				<h4 class="card-title">
					<i class="material-icons" (click)="back()">arrow_left</i>Create Vendor
				</h4>
			</div>
			<div class="card-body">
				<form [formGroup]="vendorForm" class="text-dark" (ngSubmit)="updateVendor()">
					<div class="section-group">
						<p class="section-label">Vendor</p>
						<div class="row">
							<div class="col-md-12">
								<app-address-lookup (setAddress)="getAddress($event)" adressType="establishment"></app-address-lookup>
							</div>
						</div>
						<div class="row mt-2">
							<div class="col-md-6">
								<mat-form-field class="full-width" appearance="outline">
									<mat-label>Vendor Name</mat-label>
									<input matInput formControlName="suppname">
									<mat-error *ngIf="vendorForm.get('suppname')?.invalid && vendorForm.get('suppname')?.touched">Vendor name is required</mat-error>
								</mat-form-field>
							</div>
							<div class="col-md-6">
								<mat-form-field class="full-width" appearance="outline">
									<mat-label>Vendor ID</mat-label>
									<input matInput formControlName="supplierid">
									<mat-hint>Auto-generated; edit to override</mat-hint>
									<mat-error *ngIf="vendorForm.get('supplierid')?.hasError('isNewvendor') || vendorForm.get('supplierid')?.hasError('duplicate')">
										"{{ vendorForm.get('supplierid')?.value }}" already exists as a Vendor ID
									</mat-error>
									<mat-error *ngIf="vendorForm.get('supplierid')?.hasError('required')">Vendor ID is required</mat-error>
								</mat-form-field>
							</div>
						</div>
					</div>

					<mat-divider class="section-divider"></mat-divider>

					<div class="section-group">
						<p class="section-label">Billing Address</p>
						<div class="row">
							<div class="col-md-6">
								<mat-form-field class="full-width" appearance="outline">
									<mat-label>Address 1</mat-label>
									<input matInput formControlName="address1">
									<mat-error *ngIf="vendorForm.get('address1')?.invalid && vendorForm.get('address1')?.touched">Address is required</mat-error>
								</mat-form-field>
							</div>
							<div class="col-md-6">
								<mat-form-field class="full-width" appearance="outline">
									<mat-label>Address 2</mat-label>
									<input matInput formControlName="address2">
								</mat-form-field>
							</div>
						</div>
						<div class="row">
							<div class="col-md-4">
								<mat-form-field class="full-width" appearance="outline">
									<mat-label>City</mat-label>
									<input matInput formControlName="address3">
									<mat-error *ngIf="vendorForm.get('address3')?.invalid && vendorForm.get('address3')?.touched">City is required</mat-error>
								</mat-form-field>
							</div>
							<div class="col-md-3">
								<mat-form-field class="full-width" appearance="outline">
									<mat-label>Region</mat-label>
									<mat-select formControlName="address4">
										<mat-option *ngFor="let zone of zones?.zones" [value]="zone.code">{{ zone.code }}</mat-option>
									</mat-select>
									<mat-error *ngIf="vendorForm.get('address4')?.invalid && vendorForm.get('address4')?.touched">Region is required</mat-error>
								</mat-form-field>
							</div>
							<div class="col-md-2">
								<mat-form-field class="full-width" appearance="outline">
									<mat-label>Postal</mat-label>
									<input matInput formControlName="address5">
									<mat-error *ngIf="vendorForm.get('address5')?.invalid && vendorForm.get('address5')?.touched">Postal is required</mat-error>
								</mat-form-field>
							</div>
							<div class="col-md-3">
								<mat-form-field class="full-width" appearance="outline">
									<mat-label>Country</mat-label>
									<input matInput formControlName="address6">
									<mat-error *ngIf="vendorForm.get('address6')?.invalid && vendorForm.get('address6')?.touched">Country is required</mat-error>
								</mat-form-field>
							</div>
						</div>
					</div>

					<mat-divider class="section-divider"></mat-divider>

					<div class="section-group">
						<p class="section-label">Contact & Defaults</p>
						<div class="row">
							<div class="col-md-4">
								<mat-form-field class="full-width" appearance="outline">
									<mat-label>Email</mat-label>
									<input matInput formControlName="email">
									<mat-error *ngIf="vendorForm.get('email')?.invalid && vendorForm.get('email')?.touched">Email is required</mat-error>
								</mat-form-field>
							</div>
							<div class="col-md-4">
								<mat-form-field class="full-width" appearance="outline">
									<mat-label>Phone</mat-label>
									<input formControlName="telephone" matInput mask="(000) 000-0000" [showMaskTyped]="true">
									<mat-error *ngIf="vendorForm.get('telephone')?.invalid && vendorForm.get('telephone')?.touched">Phone is required</mat-error>
								</mat-form-field>
							</div>
							<div class="col-md-4">
								<mat-form-field class="full-width" appearance="outline">
									<mat-label>Website</mat-label>
									<input matInput formControlName="url">
								</mat-form-field>
							</div>
						</div>
						<div class="row">
							<div class="col-md-4">
								<mat-form-field class="full-width" appearance="outline" *ngIf="types">
									<mat-label>Vendor Type</mat-label>
									<mat-select formControlName="supptype">
										<mat-option *ngFor="let type of types.supptypes" [value]="type.typeid">{{ type.typename }}</mat-option>
									</mat-select>
									<mat-error *ngIf="vendorForm.get('supptype')?.invalid && vendorForm.get('supptype')?.touched">Vendor type is required</mat-error>
								</mat-form-field>
							</div>
							<div class="col-md-4">
								<mat-form-field class="full-width" appearance="outline" *ngIf="paymentterms">
									<mat-label>Payment Terms</mat-label>
									<mat-select formControlName="paymentterms">
										<mat-option *ngFor="let term of paymentterms" [value]="term?.termsindicator">{{ term.terms }}</mat-option>
									</mat-select>
									<mat-error *ngIf="vendorForm.get('paymentterms')?.invalid && vendorForm.get('paymentterms')?.touched">Payment terms are required</mat-error>
								</mat-form-field>
							</div>
							<div class="col-md-4">
								<mat-form-field class="full-width" appearance="outline" *ngIf="taxes">
									<mat-label>Tax Group</mat-label>
									<mat-select formControlName="taxgroupid">
										<mat-option *ngFor="let tax of taxes" [value]="tax?.taxgroupid">{{ tax.taxgroupdescription }}</mat-option>
									</mat-select>
									<mat-error *ngIf="vendorForm.get('taxgroupid')?.invalid && vendorForm.get('taxgroupid')?.touched">Tax group is required</mat-error>
								</mat-form-field>
							</div>
						</div>
						<div class="row">
							<div class="col-md-4">
								<mat-form-field class="full-width" appearance="outline" *ngIf="currencies">
									<mat-label>Currency</mat-label>
									<mat-select formControlName="currcode">
										<mat-option *ngFor="let currency of currencies" [value]="currency?.currabrev">
											{{ currency.currabrev }} {{ currency.currency }}
										</mat-option>
									</mat-select>
									<mat-error *ngIf="vendorForm.get('currcode')?.invalid && vendorForm.get('currcode')?.touched">Currency is required</mat-error>
								</mat-form-field>
							</div>
							<div class="col-md-4">
								<mat-form-field class="full-width" appearance="outline" *ngIf="bankaccounts">
									<mat-label>Remit Bank Account</mat-label>
									<mat-select formControlName="bankact">
										<mat-option *ngFor="let account of bankaccounts" [value]="account.accountcode">{{ account.bankaccountname }}</mat-option>
									</mat-select>
									<mat-error *ngIf="vendorForm.get('bankact')?.invalid && vendorForm.get('bankact')?.touched">Remit account is required</mat-error>
								</mat-form-field>
							</div>
							<div class="col-md-4">
								<mat-form-field class="full-width" appearance="outline">
									<mat-label>Remittance</mat-label>
									<input matInput formControlName="remittance">
									<mat-error *ngIf="vendorForm.get('remittance')?.invalid && vendorForm.get('remittance')?.touched">Remittance is required</mat-error>
								</mat-form-field>
							</div>
						</div>
					</div>

					<div class="section-group" *ngIf="banking">
						<mat-divider class="section-divider"></mat-divider>
						<p class="section-label">Banking</p>
						<div class="row">
							<div class="col-md-6">
								<mat-form-field class="full-width" appearance="outline">
									<mat-label>Beneficiary Name</mat-label>
									<input matInput formControlName="bankbeneficiary">
								</mat-form-field>
							</div>
							<div class="col-md-3">
								<mat-form-field class="full-width" appearance="outline">
									<mat-label>BN #</mat-label>
									<input matInput formControlName="bn">
									<mat-hint>Required if no SIN</mat-hint>
								</mat-form-field>
							</div>
							<div class="col-md-3">
								<mat-form-field class="full-width" appearance="outline">
									<mat-label>SIN #</mat-label>
									<input matInput formControlName="sin">
									<mat-hint>Required if no BN</mat-hint>
								</mat-form-field>
							</div>
						</div>
						<div class="row">
							<div class="col-md-4">
								<mat-form-field class="full-width" appearance="outline">
									<mat-label>Bank Name</mat-label>
									<input matInput formControlName="bankname">
								</mat-form-field>
							</div>
							<div class="col-md-4">
								<mat-form-field class="full-width" appearance="outline">
									<mat-label>Bank Transit #</mat-label>
									<input matInput formControlName="banktransitno">
								</mat-form-field>
							</div>
							<div class="col-md-4">
								<mat-form-field class="full-width" appearance="outline">
									<mat-label>Bank Swift Code</mat-label>
									<input matInput formControlName="bankswiftcode">
								</mat-form-field>
							</div>
						</div>
						<div class="row">
							<div class="col-md-4">
								<mat-form-field class="full-width" appearance="outline">
									<mat-label>Bank Account #</mat-label>
									<input matInput formControlName="bankaccountno">
									<mat-hint>Required if no IBAN</mat-hint>
								</mat-form-field>
							</div>
							<div class="col-md-4">
								<mat-form-field class="full-width" appearance="outline">
									<mat-label>IBAN</mat-label>
									<input matInput formControlName="iban">
									<mat-hint>Required if no Bank Account #</mat-hint>
								</mat-form-field>
							</div>
							<div class="col-md-4">
								<mat-form-field class="full-width" appearance="outline">
									<mat-label>Preferred Currency</mat-label>
									<mat-select formControlName="bankcurrencypref">
										<mat-option *ngFor="let currency of currencies" [value]="currency?.currabrev">
											{{ currency.currabrev }} {{ currency.currency }}
										</mat-option>
									</mat-select>
								</mat-form-field>
							</div>
						</div>
						<div class="row">
							<div class="col-md-12">
								<app-address-lookup [include_canada]="true" (setAddress)="getAddress($event, 'bank')" adressType="establishment"></app-address-lookup>
							</div>
						</div>
						<div class="row">
							<div class="col-md-4">
								<mat-form-field class="full-width" appearance="outline">
									<mat-label>Bank Address 1</mat-label>
									<input matInput formControlName="bankaddress1">
								</mat-form-field>
							</div>
							<div class="col-md-4">
								<mat-form-field class="full-width" appearance="outline">
									<mat-label>Bank Address 2</mat-label>
									<input matInput formControlName="bankaddress2">
								</mat-form-field>
							</div>
							<div class="col-md-4">
								<mat-form-field class="full-width" appearance="outline">
									<mat-label>Bank City</mat-label>
									<input matInput formControlName="bankaddress3">
								</mat-form-field>
							</div>
						</div>
						<div class="row">
							<div class="col-md-4">
								<mat-form-field class="full-width" appearance="outline">
									<mat-label>Bank Region</mat-label>
									<input matInput formControlName="bankaddress4">
								</mat-form-field>
							</div>
							<div class="col-md-4">
								<mat-form-field class="full-width" appearance="outline">
									<mat-label>Bank Postal</mat-label>
									<input matInput formControlName="bankaddress5">
								</mat-form-field>
							</div>
							<div class="col-md-4">
								<mat-form-field class="full-width" appearance="outline">
									<mat-label>Bank Country</mat-label>
									<input matInput formControlName="bankaddress6">
								</mat-form-field>
							</div>
						</div>
					</div>

					<div class="form-actions">
						<button mat-button type="button" (click)="back()">Cancel</button>
						<button mat-raised-button color="primary" type="submit">Add Vendor</button>
					</div>
				</form>
			</div>
		</div>
	</div>
</div>
